import { RouteRecordRaw } from 'vue-router';

export const routes: Array<RouteRecordRaw> = [
  {
    path: 'reminders',
    name: 'ReminderList',
    component: () => import('~/views/reminders/lists/ReminderList.vue'),
    meta: {
      title: 'Напоминания',
    }
  },
  {
    path: 'reminders/detail/:id?',
    name: 'ReminderDetails',
    component: () => import('~/views/reminders/list-items/ReminderDetails.vue'),
    meta: {
      title: 'Напоминание',
    }
  },
];